/**
 * The following styled components are used in various Users related pages and components,
 * including but not limited to Manage Users, Create User, Edit User, and related sub-components.
 */
import styled from 'styled-components';
import theme from 'shared/css/theme';
import { Alert } from '@takecasper/acuity-design-system';

export const ButtonContainerStyled = styled.div`
  display: flex;
  justify-content: end;
  gap: 1rem;
`;

export const ModalBodyStyled = styled.div`
  display: flex;
  min-height: 8rem;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const TextInputWrapper = styled.div`
  width: 20rem;
  input {
    border: 1px solid ${theme.colors.grey.dark};
  }
`;

export const AlertStyled = styled(Alert)`
  width: 42rem;
  margin-bottom: 1rem;
`;

export const NumberedList = styled.ol`
  list-style-type: decimal;
  padding-left: 1rem;
`;
